import React, { FC } from 'react';

import { InverseButton } from '@crehana/ui';
import { useTranslation } from '@crehana/i18n';

interface ITemporalAccessButton {
  isDark?: boolean;
  enrollmentAccessPreviewUrl?: string;
  isUserSofeAndCourseIsOneMonthOld?: boolean;
}

const TemporalAccessButton: FC<ITemporalAccessButton> = ({
  enrollmentAccessPreviewUrl,
  isUserSofeAndCourseIsOneMonthOld,
  isDark,
}) => {
  const { t } = useTranslation();

  return (
    <InverseButton
      href={enrollmentAccessPreviewUrl}
      full
      className="mt-16 rounded-10"
      // @ts-expect-error
      testId="watch-course"
      label={t('TRY_COURSE', {
        defaultValue: '¡Pruébalo ahora!',
      })}
      disabled={isUserSofeAndCourseIsOneMonthOld}
      isDark={isDark}
    />
  );
};

export default TemporalAccessButton;
